import _classCallCheck from "/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/d/EJSAK/CarPlatform-v2-frontend/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import OverlayScrollbars from 'overlayscrollbars';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var OverlayScrollbarsComponent = /*#__PURE__*/function (_Component) {
  _inherits(OverlayScrollbarsComponent, _Component);

  var _super = _createSuper(OverlayScrollbarsComponent);

  function OverlayScrollbarsComponent(props) {
    var _this;

    _classCallCheck(this, OverlayScrollbarsComponent);

    _this = _super.call(this, props);
    _this._osInstance = null;
    _this._osTargetRef = React.createRef();
    return _this;
  }

  _createClass(OverlayScrollbarsComponent, [{
    key: "osInstance",
    value: function osInstance() {
      return this._osInstance;
    }
  }, {
    key: "osTarget",
    value: function osTarget() {
      return this._osTargetRef.current || null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._osInstance = OverlayScrollbars(this.osTarget(), this.props.options || {}, this.props.extensions);
      mergeHostClassNames(this._osInstance, this.props.className);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (OverlayScrollbars.valid(this._osInstance)) {
        this._osInstance.destroy();

        this._osInstance = null;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (OverlayScrollbars.valid(this._osInstance)) {
        this._osInstance.options(this.props.options);

        if (prevProps.className !== this.props.className) {
          mergeHostClassNames(this._osInstance, this.props.className);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          divProps = __rest(_a, ["options", "extensions", "children", "className"]);

      return React.createElement("div", Object.assign({
        className: "os-host"
      }, divProps, {
        ref: this._osTargetRef
      }), React.createElement("div", {
        className: "os-resize-observer-host"
      }), React.createElement("div", {
        className: "os-padding"
      }, React.createElement("div", {
        className: "os-viewport"
      }, React.createElement("div", {
        className: "os-content"
      }, this.props.children))), React.createElement("div", {
        className: "os-scrollbar os-scrollbar-horizontal "
      }, React.createElement("div", {
        className: "os-scrollbar-track"
      }, React.createElement("div", {
        className: "os-scrollbar-handle"
      }))), React.createElement("div", {
        className: "os-scrollbar os-scrollbar-vertical"
      }, React.createElement("div", {
        className: "os-scrollbar-track"
      }, React.createElement("div", {
        className: "os-scrollbar-handle"
      }))), React.createElement("div", {
        className: "os-scrollbar-corner"
      }));
    }
  }]);

  return OverlayScrollbarsComponent;
}(Component);

function mergeHostClassNames(osInstance, className) {
  if (OverlayScrollbars.valid(osInstance)) {
    var _osInstance$getElemen = osInstance.getElements(),
        host = _osInstance$getElemen.host;

    var regex = new RegExp("(^os-host([-_].+|)$)|".concat(osInstance.options().className.replace(/\s/g, "$|"), "$"), 'g');
    var osClassNames = host.className.split(' ').filter(function (name) {
      return name.match(regex);
    }).join(' ');
    host.className = "".concat(osClassNames, " ").concat(className || '');
  }
}

export { OverlayScrollbarsComponent };